import React from "react";

import { Form, Select, Collapse, DatePicker, Button } from "antd";

import moment from "moment-timezone";
moment.tz.setDefault("Etc/UTC");

const { Option } = Select;
const { Panel } = Collapse;
const { RangePicker } = DatePicker;

const apps = [
  "myDocs",
  "Settings",
  "QMS",
  "Compliance",
  "ULP",
  "SFTP",
  "eForms",
  "Marriott FOSSE",
  "B&F",
];

class FormOne extends React.Component {
  state = {
    forChangeValue: null,
  };
  formOneformRef = React.createRef();

  hmgOnChange = (data) => {
    this.formOneformRef.current.setFieldsValue({
      project: undefined,
      hotel: undefined,
    });
    this.setState({ forChangeValue: data });
  };

  projectOnChange = (data) => {
    this.setState({ forChangeValue: data });
  };

  render() {
    const { formOneOnFinish, hmgMainGetData, hmgGetData, hotelGetData } =
      this.props;
    let formOneValue = null;
    if (this.formOneformRef && this.formOneformRef.current) {
      formOneValue = this.formOneformRef.current.getFieldValue();
    }

    const hmgMainOptions = hmgMainGetData
      .sort((a, b) => a.hmg_name.localeCompare(b.hmg_name))
      .map((d) => <Option key={d._id}>{d.hmg_name}</Option>);
    const hmgOptions = hmgGetData
      .filter((item) => {
        if (formOneValue && formOneValue.hmg) {
          if (item.hmg_id === formOneValue.hmg) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      })
      .sort((a, b) => a.project_name.localeCompare(b.project_name))
      .map((d) => <Option key={d._id}>{d.project_name}</Option>);

    const hotelsOptions = hotelGetData
      .filter((item) => {
        if (formOneValue && formOneValue.project) {
          if (item.primary_hmg_id === formOneValue.project) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      })
      .sort((a, b) => a.hotel_code.localeCompare(b.hotel_code))
      .map((d) => (
        <Option key={d._id}>
          {d.hotel_code} - {d.hotel_name}
        </Option>
      ));

    const appOptions = apps
      .sort((a, b) => a.localeCompare(b))
      .map((d) => <Option key={d}>{d}</Option>);
    return (
      <div>
        <Collapse defaultActiveKey={["1_1"]} expandIconPosition="end">
          <Panel header="Search" key="1_1">
            <Form
              ref={this.formOneformRef}
              // layout="vertical"
              name="control-ref"
              onFinish={formOneOnFinish}
              labelCol={{
                xs: { span: 24 },
                sm: { span: 6 },
                md: { span: 6 },
                lg: { span: 5 },
                xl: { span: 5 },
                xxl: { span: 5 },
              }}
              wrapperCol={{
                xs: { span: 24 },
                sm: { span: 18 },
                md: { span: 18 },
                lg: { span: 15 },
                xl: { span: 12 },
                xxl: { span: 12 },
              }}
            >
              <Form.Item
                name="date"
                label="Date"
                style={{ marginBottom: "8px" }}
              >
                <RangePicker
                  showTime={{
                    format: "HH:mm",
                    defaultValue: [
                      moment("00:00:00", "HH:mm:ss"),
                      moment("11:59:59", "HH:mm:ss"),
                    ],
                  }}
                  // format="YYYY-MM-DD HH:mm"
                />
              </Form.Item>

              <Form.Item name="hmg" label="HMG" style={{ marginBottom: "8px" }}>
                <Select
                  showSearch
                  optionFilterProp="children"
                  placeholder="All HMGs"
                  allowClear={true}
                  onChange={this.hmgOnChange}
                  notFoundContent={null}
                >
                  {hmgMainOptions}
                </Select>
              </Form.Item>

              <Form.Item
                name="project"
                label="Project"
                style={{ marginBottom: "8px" }}
              >
                <Select
                  showSearch
                  optionFilterProp="children"
                  placeholder="All Projects"
                  allowClear={true}
                  onChange={this.projectOnChange}
                  notFoundContent={null}
                >
                  {hmgOptions}
                </Select>
              </Form.Item>

              <Form.Item
                name="hotel"
                label="Hotel"
                style={{ marginBottom: "8px" }}
              >
                <Select
                  showSearch
                  optionFilterProp="children"
                  placeholder="All Hotels"
                  allowClear={true}
                  notFoundContent={null}
                  mode="multiple"
                >
                  {hotelsOptions}
                </Select>
              </Form.Item>

              <Form.Item name="app" label="App">
                <Select
                  showSearch
                  optionFilterProp="children"
                  placeholder="All Apps"
                  allowClear={true}
                  notFoundContent={null}
                  mode="multiple"
                >
                  {appOptions}
                </Select>
              </Form.Item>

              <Form.Item
                wrapperCol={{ span: 12, offset: 5 }}
                style={{ marginBottom: "0px" }}
              >
                <Button
                  type="primary"
                  htmlType="Search"
                  // disabled={
                  //   this.formRef.current.isFieldsTouched(true) ||
                  //   this.formRef.current.getFieldsError().filter(({ errors }) => errors.length).length
                  // }
                >
                  Search
                </Button>
              </Form.Item>
            </Form>
          </Panel>
        </Collapse>
      </div>
    );
  }
}

export default FormOne;
